export const site = {
  name: 'Unbelievable Remodeling & Painting',
  shortName: 'UNBELIEVABLE',
  phoneDisplay: '(502) 555-0147',
  phoneHref: 'tel:+15025550147',
  email: 'hello@unbelievableremodeling.com',
  serviceArea: 'Proudly serving homeowners throughout Kentucky',
}

export const navLinks = [
  { label: 'Home', href: '#top' },
  { label: 'Services', href: '#services' },
  { label: 'Our Work', href: '#work' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' },
]

export const trustItems = [
  'Quality Craftsmanship',
  'Professional Service',
  'Attention to Detail',
  'Free Estimates',
  'Kentucky Local',
]
